

import api from '@/api/ks/courseContent/column.js'
const state = {
	detailColumnObj: {},
	saveId: ''
}
const mutations = {
	specialinfoState(state, data) {
		state.detailColumnObj = data
	},
	createdspecialState(state, data) {
		state.saveId = data.id
	},
	movespecialState(state, data) {
		state.saveId = data.id
	}
}
const actions = {
	specialinfo({ commit }, params = {}) {
		api.specialinfo(params, (res) => {
			commit('specialinfoState', res)
		})
	},
	async createdspecial({ commit }, params = {}) {
		let res = await api.createdspecial(params)
		commit('createdspecialState', res)
	},
	async movespecialState({ commit }, params = {}) {
		try {
			let res = await api.movespecialState(params)
			commit('movespecialStateState', res)
			return 'success'
		} catch (error) {
			return 'error'
		}
	},
	async movespecial({ commit }, params = {}) {
		let res = await api.movespecial(params)
		commit('movespecialState', res)
		return res
	},
	async upstatus({}, params = {}) {
		return await api.upstatus(params)
	},
	async createH5linkAPI({}, params = {}) {
		console.log('1111111-2222')
		return await api.createH5linkAPI(params)
	}
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}